import { Route, Routes } from "react-router-dom";
import SelectionPage from "./SelectionPage";

function App() {
  return (
    <Routes>
      <Route path="id/:lotteryId" element={<SelectionPage />} />
      <Route path="*" element={<>Not found</>} />
    </Routes>
  );
}

export default App;
